export const normalizeAnswerOptions = (value) => {
  if (!Array.isArray(value)) return [];
  const options = [...new Set(value
    .filter(item => typeof item === 'string')
    .map(item => item.trim())
    .filter(item => item && item.length <= 60 &&
      !/모르|몰라|직접\s?입력|기타|추천/.test(item)))];
  return options.length >= 2 ? options.slice(0, 4) : [];
};
